const state = () => ({
  baseDialogOpen: false,
  pdfDialogOpen: false,
  allDialogOpen: false,
  dialogTitle: null,
  contentDialog: {
    addNote: false,
    allNotes: false,
  },
  noteFor: null,
  noteList: null,
  updateList: null,
  textNote: "",
  currentNote: null,
  currentFixed: null,
  dialogBuilder: false,
  dialogBuilderText: "",
  filterSaverDialog: false,
  filterSaverDialogData: null,
  confirmDeleteDialog: null,
  confirmDeleteDialogData: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  setContent(state, data) {
    for (const key in state.contentDialog) {
      state.contentDialog[key] = false;
    }
    state.contentDialog[data.label] = data.data;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
